import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { AGG, AGGMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AggFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AggFormComponent),
    },
  ],
  selector: 'app-agg-form',
  styleUrls: ['./agg-form.component.scss'],
  templateUrl: './agg-form.component.html',
})
export class AggFormComponent extends BaseCtrlValueAccessorFormArrayComponent<AGG> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage AGG without a control');
    }

    const control = this.formManager.makeForm(AGGMeta, {} as AGG);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage AGG without a control');
    }

    this.form.removeAt(index);
  }
}
